import { Maybe } from 'graphql/jsutils/Maybe';
import { addDays, isPast, isValid, parseISO } from 'date-fns';
import { TuiInputDateModule } from '@taiga-ui/kit';
import { TuiTextfieldControllerModule } from '@taiga-ui/core';
import { TuiMobileCalendarDialogModule } from '@taiga-ui/addon-mobile';
import { TranslateModule } from '@ngx-translate/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Component, Input, OnChanges } from '@angular/core';
import { DatePipe, NgIf } from '@angular/common';

import { NativeDayDirective, TuiDayPipe } from '@iss/wo-common/taiga';
import {
  InputDirective,
  LabelDirective,
  FormFieldComponent,
  FormFieldErrorDirective,
  ControlStatusDirective,
  MinDateDirective,
} from '@iss/core/forms';

@Component({
  selector: 'wo-recurrence-schedule-date-range',
  templateUrl: './recurrence-schedule-date-range.component.html',
  standalone: true,
  imports: [
    ControlStatusDirective,
    DatePipe,
    FormFieldComponent,
    FormFieldErrorDirective,
    FormsModule,
    InputDirective,
    LabelDirective,
    MinDateDirective,
    NativeDayDirective,
    NgIf,
    ReactiveFormsModule,
    TranslateModule,
    TuiDayPipe,
    TuiInputDateModule,
    TuiMobileCalendarDialogModule,
    TuiTextfieldControllerModule,
  ],
})
export class RecurrenceScheduleDateRangeComponent implements OnChanges {
  @Input({ required: true }) public startDate!: FormControl<string | undefined>;
  @Input({ required: true }) public endDate!: FormControl<string | undefined>;
  @Input() public readonly: Maybe<boolean>;
  @Input() public minStart: Maybe<Date>;
  public minEnd!: Date;

  public ngOnChanges(): void {
    this.adjustMinEnd();
  }

  public adjustMinEnd(): void {
    if (this.minStart) {
      const start = this.startDate.value ? parseISO(this.startDate.value) : null;
      const end = isValid(start) ? addDays(start!, 1) : this.minStart;
      this.minEnd = isPast(end) ? new Date() : end;
    }
  }
}
